import React, { useMemo } from "react";

import { useNeighborhoodHero } from "~/sdks/NeighborhoodHero/context";
import { MapPinIcon } from "@phosphor-icons/react";

import * as styles from "./styles";

export const Header = () => {
  const { isLoading, locationInfo, neighborhoodImage, isFallbackImage } =
    useNeighborhoodHero();

  const style = useMemo(() => {
    if (!neighborhoodImage) {
      return {};
    }

    return {
      backgroundImage: `url("${neighborhoodImage}")`,
    };
  }, [neighborhoodImage]);

  if (isLoading) {
    return null;
  }

  return (
    <div
      data-testid="header-container"
      data-cy="header-container"
      className={styles.container}
      style={style}
      data-has-image={neighborhoodImage !== null}
      data-use-backdrop={!isFallbackImage && neighborhoodImage !== null}
    >
      <div className={styles.gradientContainer}>
        <MapPinIcon className={styles.icon} />
        <h1
          data-testid="micro-location"
          data-cy="micro-location"
          className={styles.microLocation}
        >
          {locationInfo?.microLocation}
        </h1>
        <div
          data-testid="macro-location"
          data-cy="macro-location"
          className={styles.macroLocation}
        >
          {locationInfo?.macroLocation}
        </div>
      </div>
    </div>
  );
};
